// "YEN → PIL" autofill for the PIL declaration form on Tepez.
//
// Flow: admin clicks "Send to PIL" → we open the Tepez form with the form's
// data in the URL hash (#yen=…) and also copy it to the clipboard. Dave then
// clicks the "YEN → PIL" bookmark on the Tepez page, which fills every field
// it can find by its Hebrew label. Writer/composer, attachments, signature
// and the final שליחה stay manual.
//
// The bookmarklet source is a plain ES5 string on purpose: the CRA build
// transpiles real functions (async/await → helpers), which would break once
// the code is lifted out into a bookmark.

export const TEPEZ_URL = 'https://app.tepez.co.il/c/62fd18798dc969106d24f299/';
export const LABEL_NAME = 'YEN SOUND';
const DECLARER_KEY = 'yenPilDeclarer';

export function loadDeclarer() {
  try { return JSON.parse(localStorage.getItem(DECLARER_KEY) || 'null'); } catch { return null; }
}
export function saveDeclarer(d) {
  try { localStorage.setItem(DECLARER_KEY, JSON.stringify(d)); } catch (_) {}
}
export function declarerComplete(d) {
  return !!(d && d.first && d.last && d.id && d.phone && d.email);
}

/* Form row (from /api/signed-forms list) → what Tepez needs. */
export function buildPilPayload(form) {
  const tracks = (Array.isArray(form.tracks) ? form.tracks : []).map(t => {
    const release = (t.release || '').trim();
    const track = (t.track || '').trim();
    return {
      performer: (t.storePerformer || form.artist_name || '').trim(),
      track,
      note: release && release !== track ? `שם אלבום: ${release}` : '',
    };
  });
  return { v: 1, artist: form.artist_name || '', tracks };
}

export function encodePayload(payload) {
  return btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
}

export function tepezLink(payload) {
  return `${TEPEZ_URL}#yen=${encodeURIComponent(encodePayload(payload))}`;
}

const SRC = `function(D){
  function norm(t){return (t||'').replace(/[*\\u200e\\u200f?]/g,'').replace(/\\s+/g,' ').trim();}
  var filled=0, missed=[];
  function readPayload(){
    var m=location.hash.match(/[#&]yen=([^&]+)/), raw=m?m[1]:null;
    if(!raw){raw=prompt('YEN \\u2192 PIL: \\u05d4\\u05d3\\u05d1\\u05d9\\u05e7\\u05d5 \\u05db\\u05d0\\u05df \\u05d0\\u05ea \\u05d4\\u05e0\\u05ea\\u05d5\\u05e0\\u05d9\\u05dd \\u05e9\\u05d4\\u05d5\\u05e2\\u05ea\\u05e7\\u05d5 \\u05de\\u05d4\\u05d3\\u05e9\\u05d1\\u05d5\\u05e8\\u05d3');}
    if(!raw)return null;
    try{return JSON.parse(decodeURIComponent(escape(atob(decodeURIComponent(raw).trim()))));}catch(e){alert('YEN \\u2192 PIL: invalid data');return null;}
  }
  function labels(text){
    var out=[],els=document.querySelectorAll('label,span,div,p,strong,b,h5,h6');
    for(var i=0;i<els.length;i++){var el=els[i];if(el.children.length>4)continue;if(el.querySelector('input,textarea,select'))continue;var t=norm(el.textContent);if(t.indexOf(text)===0&&t.length<text.length+40)out.push(el);}
    return out.filter(function(el){for(var j=0;j<out.length;j++){if(out[j]!==el&&el.contains(out[j]))return false;}return true;});
  }
  function inputFor(l){
    if(l.htmlFor){var x=document.getElementById(l.htmlFor);if(x)return x;}
    var n=l;for(var k=0;k<6&&n;k++){var c=n.querySelector&&n.querySelector('input:not([type=radio]):not([type=checkbox]):not([type=file]):not([type=hidden]),textarea');if(c)return c;n=n.parentElement;}
    return null;
  }
  function setVal(el,v){
    var proto=el.tagName==='TEXTAREA'?HTMLTextAreaElement.prototype:HTMLInputElement.prototype;
    Object.getOwnPropertyDescriptor(proto,'value').set.call(el,v);
    ['input','change','blur'].forEach(function(ev){el.dispatchEvent(new Event(ev,{bubbles:true}));});
    el.style.outline='2px solid #22c55e';filled++;
  }
  function fill(text,v,i){if(!v)return;var l=labels(text)[i||0],inp=l&&inputFor(l);if(!inp){missed.push(text+(i?' #'+(i+1):''));return;}setVal(inp,v);}
  function flag(text,i){var l=labels(text)[i||0],inp=l&&inputFor(l);if(inp)inp.style.outline='3px solid #f59e0b';}
  function pickTransferRadio(){
    var rs=document.querySelectorAll('input[type=radio]');
    for(var i=0;i<rs.length;i++){var r=rs[i],box=r.closest('label')||r.parentElement,t=box?norm(box.textContent):'';
      if(t.indexOf('\\u05db\\u05ea\\u05d1 \\u05d4\\u05e2\\u05d1\\u05e8\\u05ea')>-1){r.click();filled++;return;}}
    missed.push('radio');
  }
  function addButton(){var bs=document.querySelectorAll('button,a');for(var i=0;i<bs.length;i++){if(norm(bs[i].textContent).indexOf('\\u05d4\\u05e7\\u05dc\\u05d8\\u05d4 \\u05e0\\u05d5\\u05e1\\u05e4\\u05ea')>-1)return bs[i];}return null;}
  var data=readPayload();if(!data)return;
  var tracks=data.tracks||[];
  fill('\\u05e9\\u05dd \\u05e4\\u05e8\\u05d8\\u05d9',D.first);
  fill('\\u05e9\\u05dd \\u05de\\u05e9\\u05e4\\u05d7\\u05d4',D.last);
  fill('\\u05de\\u05e1\\u05e4\\u05e8 \\u05d6\\u05d4\\u05d5\\u05ea',D.id);
  fill('\\u05d8\\u05dc\\u05e4\\u05d5\\u05df \\u05e0\\u05d9\\u05d9\\u05d3',D.phone);
  fill('\\u05db\\u05ea\\u05d5\\u05d1\\u05ea \\u05d0\\u05d9\\u05de\\u05d9\\u05d9\\u05dc',D.email);
  pickTransferRadio();
  var tries=0;
  (function grow(){
    var have=labels('\\u05e9\\u05dd \\u05d4\\u05e7\\u05dc\\u05d8\\u05d4').length;
    if(have<tracks.length&&tries<30){var b=addButton();if(b){b.click();tries++;setTimeout(grow,350);return;}}
    for(var i=0;i<tracks.length;i++){var t=tracks[i];
      fill('\\u05e9\\u05dd \\u05d4\\u05de\\u05d1\\u05e6\\u05e2',t.performer,i);
      fill('\\u05e9\\u05dd \\u05d4\\u05e7\\u05dc\\u05d8\\u05d4',t.track,i);
      fill('\\u05d1\\u05e2\\u05dc \\u05d4\\u05de\\u05d0\\u05e1\\u05d8\\u05e8',D.label||'YEN SOUND',i);
      fill('\\u05d4\\u05e2\\u05e8\\u05d4',t.note,i);
      flag('\\u05e9\\u05dd \\u05d4\\u05db\\u05d5\\u05ea\\u05d1',i);flag('\\u05e9\\u05dd \\u05d4\\u05de\\u05dc\\u05d7\\u05d9\\u05df',i);
    }
    alert('YEN \\u2192 PIL\\n\\u2713 '+filled+' fields filled ('+tracks.length+' recordings)'+
      (missed.length?'\\n\\u26a0 Not found: '+missed.join(', '):'')+
      '\\n\\nStill yours: writer + composer (orange), attach the declaration (pp. 1\\u20132) and covers, sign, preview, send.');
  })();
}`;

/* javascript: URL for the bookmark. Declarer details are baked in, so the
   bookmark lives only in Dave's browser and nothing sensitive hits the server. */
export function buildBookmarklet(declarer) {
  const d = { first: declarer.first, last: declarer.last, id: declarer.id, phone: declarer.phone, email: declarer.email, label: LABEL_NAME };
  // eslint-disable-next-line no-script-url
  return 'javascript:' + encodeURIComponent(`(${SRC})(${JSON.stringify(d)});void 0;`);
}
